import styled from 'styled-components';
import {
  NO_BRAND_AFFINITY_DATA_BODY,
  NO_BRAND_AFFINITY_DATA_LINK,
  NO_BRAND_AFFINITY_DATA_TITLE,
} from 'modules/intelligentInsights/brandAffinityInsights/constants';
import { EmptyState } from 'ui/emptyState';
import { CampaignMissing } from 'ui/illustrations';
import { Link } from 'ui/links';
import { body1, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { BrandAffinityBackground } from 'modules/intelligentInsights/brandAffinityInsights/components/layout/BrandAffinity.styles';

const Wrapper = styled.div`
  padding: ${spacing.x12} 0;
`;

const DescriptionWrapper = styled.span`
  max-width: ${pxToRem(460)};
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

const BodyText = styled.span`
  ${body1};
  color: ${colors.textSecondary};
`;

export const BrandAffiityEmptyId = 'brand-affinity-empty';

export const BrandAffinityEmpty = () => (
  <BrandAffinityBackground>
    <Wrapper data-test={BrandAffiityEmptyId}>
      <EmptyState
        Illustration={CampaignMissing}
        title={NO_BRAND_AFFINITY_DATA_TITLE}
        subtitle={
          <DescriptionWrapper>
            <BodyText>{NO_BRAND_AFFINITY_DATA_BODY}</BodyText>
            <BodyText>
              {NO_BRAND_AFFINITY_DATA_LINK}{' '}
              <Link
                size="body1"
                href="https://support.iterable.com/hc/en-us/articles/360052990191-Brand-Affinity"
              >
                Knowledge Center
              </Link>{' '}
              .
            </BodyText>
          </DescriptionWrapper>
        }
      />
    </Wrapper>
  </BrandAffinityBackground>
);
